// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../settings_ctx';
import {Editor} from '../../../shared/editor/editor';
import {Link} from '../ui/link';
import cn from 'classnames';

interface i_agreement_message_editor_props {
    render_in_center?: boolean;
}

export const Agreement_message = (props: i_agreement_message_editor_props)=>{
    const {render_in_center = false} = props;
    const {theme} = useContext(Settings_context);
    return <div className={cn({
      [theme.content_center]: render_in_center,
      [theme.text_center]: render_in_center
    })}>
      <p className={theme.p5}>
        By installing this app you agree to the Hola&nbsp;
        <Link className={theme.link} to="/legal/sla"
          target="_blank">End User Agreement</Link>
        &nbsp;&&nbsp;
        <Link className={theme.link} to="/legal/privacy"
          target="_blank">Privacy Statement</Link>
      </p>
    </div>;
};

export const Agreement_message_editor = props=>{
    return <Editor value={props.value} on_change={props.on_change}
      editors={[
        {key: 'render_in_center', label: 'Render in center', type: 'boolean'}
      ]}/>;
};
